<template>
  <div class="camera_outer" :class="isPhoto?'line-scan':''">
    <video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
    <canvas style="display:none;" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
  </div>
</template>

<script>
import { bizURL } from "../../api/baseUrl";
export default {
  name: "CameraDialog",
  props: {
    dialogVisible: { type: Boolean },
    deleteData: { type: Object },
    isPhoto: { type: Boolean },
  },
  data() {
    return {
      videoWidth: 350,
      videoHeight: 350,
      imgSrc: "",
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      openVideo: false,
      show: true
    };
  },
  mounted() {
    if (this.show) this.getCompetence();
  },
  methods: {
    // 调用权限（打开摄像头功能）
    getCompetence() {
      var _this = this;
      _this.thisCancas = document.getElementById("canvasCamera");
      _this.thisContext = this.thisCancas.getContext("2d");
      _this.thisVideo = document.getElementById("videoCamera");
      _this.thisVideo.style.display = "block";
      // 获取媒体属性，旧版本浏览器可能不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            //不存在则报错
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = {
        audio: false,
        video: {
          width: this.videoWidth,
          height: this.videoHeight,
          transform: "scaleX(-1)"
        }
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(stream) {
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in _this.thisVideo) {
            _this.thisVideo.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream);
          }
          _this.thisVideo.onloadedmetadata = function(e) {
            _this.thisVideo.play();
          };
        })
        .catch(err => {
          console.log(err);
        });
    },
    //  绘制图片（拍照功能）
    setImage(type) {
      var _this = this;
      // canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      );
      // 获取图片base64链接
      var image = this.thisCancas.toDataURL("image/png");

// 带上前缀时需去掉前缀
      var imageSize = image.replace('data:image/png;base64,', '');
      var strLength = imageSize.length;
      var fileLength = parseInt(strLength - (strLength / 8) * 2);

      // 由字节转换为KB
      var size = "";
      size = (fileLength / 1024).toFixed(2);
      //  由字节转换为MB
      /* size = (fileLength / 1024 * 1024).toFixed(2);*/
      console.log("imgSize================================================="+size);
      if(size<35){
        _this.$router.go(-1);
        _this.$message.warning({
          message: '捕获摄像头失败，请安装摄像头！',
          duration: 2000
        });
        return false
      }else{
        if(type=='test'){

        }else {
          _this.imgSrc = image; //赋值并预览图片
          _this.setFileUpload();
        }
      }
    },
    //上传图片
    setFileUpload(data) {
      // 通过FromData构造上传数据对象
      var _this = this;
      var formdata = new FormData();
      // 以键值对的方式把上传的图片存进formdata里边
      var logObj=sessionStorage.getItem("courseLogObj")?JSON.parse(sessionStorage.getItem("courseLogObj")):{ccId:"",regId:""};
      formdata.append("BASE64", this.imgSrc);
      formdata.append("fileType", "看课照片");
      formdata.append("ccId", logObj.ccId);
      formdata.append("regId", logObj.regId);
      formdata.append("courseId", "1"); // 0 手机  1 pc
      formdata.append("fileName", "看课照片.png");
      // formdata.append("tokenId",JSON.parse(localStorage.getItem("userObj")).tokenId);

      // 发送Ajax请求config.examURL+'registration/uploadImage'
      $.ajax({
        url:
          bizURL +
          "/file/uploadBASE64?tokenId=" +
          sessionStorage.getItem("token"),
        type: "post",
        data: formdata,
        dataType:"json",
        processData: false, //禁止对数据转码,
        contentType: false, //禁止设置请求头
        success: function(res) {
          if(res.success){
            _this.returnImg =res.data;
          }else{
            _this.returnImg="没有检测到头像"//检测到文件小于10KB 可能是空文件,请检查文件BASE64
          }
          _this.$emit("getImgUrl", _this.returnImg);
          _this.$emit("child-url", _this.returnImg);
        }
      });
    },
    // 关闭摄像头
    stopNavigator() {
      this.thisVideo.srcObject.getTracks()[0].stop();
    },
    // base64转文件，此处没用到
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }
  }
};
</script>
